import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaClock,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPhoneAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* TOP INFO BAR */}

      <div className="bg-gray-100 text-gray-700 text-sm px-8 py-2 hidden md:block">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          {/* LEFT INFO */}

          <div className="flex gap-6 items-center">
            <div className="flex items-center gap-2">
              <FaMapMarkerAlt className="text-blue-600" />
              Lake Central Tower, Business Bay
            </div>

            <div className="flex items-center gap-2">
              <FaEnvelope className="text-blue-600" />
              info@lumisdocumentsclearing.com
            </div>

            <div className="flex items-center gap-2">
              <FaClock className="text-blue-600" />
              Mon - Fri 9:30AM - 6:30PM
            </div>
          </div>

          {/* SOCIAL MEDIA */}

          <div className="flex gap-4 text-gray-600 text-lg">
            <a href="#!" className="hover:text-blue-600 transition">
              <FaFacebookF />
            </a>

            <a href="#!" className="hover:text-blue-600 transition">
              <FaInstagram />
            </a>

            <a href="#!" className="hover:text-blue-600 transition">
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </div>

      {/* MAIN NAVBAR */}

      <nav
        className={`sticky top-0 z-50 transition duration-300 ${
          scrolled ? "bg-black shadow-lg py-3" : "bg-black py-4"
        }`}
      >
        <div className="max-w-7xl mx-auto px-8 flex justify-between items-center">
          {/* LOGO */}

          <Link to="/" className="flex items-center">
            <img 
              src="/logo_cropped.png" 
              alt="Lumis Documents Clearing" 
              className="h-10 md:h-14 w-auto object-contain mix-blend-screen"
            />
          </Link>

          {/* MENU */}

          <ul className="hidden md:flex gap-10 text-white font-medium">
            <li>
              <Link to="/" className="hover:text-blue-400 transition">
                Home
              </Link>
            </li>

            <li>
              <Link to="/about" className="hover:text-blue-400 transition">
                About
              </Link>
            </li>

            <li>
              <Link to="/services" className="hover:text-blue-400 transition">
                Services
              </Link>
            </li>

            <li>
              <Link to="/countries" className="hover:text-blue-400 transition">
                Countries
              </Link>
            </li>

            <li>
              <Link
                to="/testimonials"
                className="hover:text-blue-400 transition"
              >
                Testimonials
              </Link>
            </li>

            <li>
              <Link to="/contact" className="hover:text-blue-400 transition">
                Contact
              </Link>
            </li>
          </ul>

          {/* CALL BUTTON */}

          <a
            href="tel:+971547662665"
            className="hidden md:flex items-center gap-2 bg-blue-600 px-5 py-2 rounded-full text-white hover:bg-blue-700 transition"
          >
            <FaPhoneAlt />
            Call Now
          </a>

          {/* MOBILE MENU BUTTON */}
          <button 
            className="md:hidden text-white text-2xl focus:outline-none"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* MOBILE MENU DROPDOWN */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-black/95 backdrop-blur-md absolute top-full left-0 w-full shadow-2xl border-t border-gray-800">
            <ul className="flex flex-col text-white font-medium p-6 gap-6">
              <li>
                <Link to="/" onClick={() => setMobileMenuOpen(false)} className="hover:text-blue-400 block transition">Home</Link>
              </li>
              <li>
                <Link to="/about" onClick={() => setMobileMenuOpen(false)} className="hover:text-blue-400 block transition">About</Link>
              </li>
              <li>
                <Link to="/services" onClick={() => setMobileMenuOpen(false)} className="hover:text-blue-400 block transition">Services</Link>
              </li>
              <li>
                <Link to="/countries" onClick={() => setMobileMenuOpen(false)} className="hover:text-blue-400 block transition">Countries</Link>
              </li>
              <li>
                <Link to="/testimonials" onClick={() => setMobileMenuOpen(false)} className="hover:text-blue-400 block transition">Testimonials</Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => setMobileMenuOpen(false)} className="hover:text-blue-400 block transition">Contact</Link>
              </li>
              <li className="pt-4 border-t border-gray-800">
                <a
                  href="tel:+971547662665"
                  className="flex items-center justify-center gap-2 bg-blue-600 px-5 py-3 rounded-xl text-white hover:bg-blue-700 transition shadow"
                >
                  <FaPhoneAlt />
                  Call Now
                </a>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </>
  );
}

export default Navbar;
